import { render, staticRenderFns } from "./ContentAccessRestrictionsReview.vue?vue&type=template&id=37adcb9e&"
import script from "./ContentAccessRestrictionsReview.vue?vue&type=script&lang=js&"
export * from "./ContentAccessRestrictionsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports